import VueJwtDecode from "vue-jwt-decode";
class Permisos {
    tienePermisoOperacion(idSubModuloOperacion)
    {
        var jwtDesk = localStorage.jwt;
        var operm = VueJwtDecode.decode(jwtDesk).operaciones_permitidas;        
        return operm.includes(idSubModuloOperacion);        
    }
}
export default new Permisos();